import Accordion from 'react-bootstrap/Accordion';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
//===--- Icons
import { MdMail, MdWeb  } from 'react-icons/md';
import { FaLinkedin, FaGithubSquare  } from 'react-icons/fa';

export default function Account() {
    return (
    <section id='about'>
        <div className='bg-div bg-body-secondary' data-bs-theme='dark'></div>
        <Navbar className='bg-body-tertiary secondary-navbar' data-bs-theme='dark'>
            <Container>
                <Accordion defaultActiveKey='0'>
                    <Accordion.Item eventKey='1' className='border-0'>
                        <Accordion.Header><h6>About Us:</h6></Accordion.Header>
                            <Accordion.Body>
                                <Nav className='me-auto'>
                                    <Nav.Link href='company'>Our Company</Nav.Link>
                                    <Nav.Link href='beverages'>Our Beverages</Nav.Link>
                                    <Nav.Link href='customer_service'>Customer Service</Nav.Link>
                                    <Nav.Link href='contact'>Contact Us</Nav.Link>
                                </Nav>
                            </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Container>
        </Navbar>
        <Navbar className='bg-body-tertiary' data-bs-theme='dark'>
            <Container>
                <hr />
            </Container>
        </Navbar>
        <Navbar className='bg-body-tertiary' data-bs-theme='dark'>
            <Container>
                <Nav className='me-auto icons'>
                    <Nav.Link href='mailto:aguayo.jesus2003@gmail.com'><MdMail /></Nav.Link>
                    <Nav.Link href='https://jesus-404.github.io/'><MdWeb  /></Nav.Link>
                    <Nav.Link href='https://www.linkedin.com/in/jesus-aguayo/'><FaLinkedin /></Nav.Link>
                    <Nav.Link href='https://github.com/jesus-404'><FaGithubSquare /></Nav.Link>
                </Nav>
            </Container>
        </Navbar>
        <Navbar className='bg-body-tertiary' data-bs-theme='dark'>
            <Container>
                <Navbar.Collapse className='justify-content-center'>
                    <Nav>
                        <Nav.Link href='link1'>Privacy Notice</Nav.Link>
                        <h5 className='navbar-text'>|</h5>
                        <Nav.Link href='link2'>Terms of Use</Nav.Link>
                        <h5 className='navbar-text'>|</h5>
                        <Nav.Link href='link3'>Cookie Prefences</Nav.Link>
                        <h5 className='navbar-text'>|</h5>
                        <Nav.Link href='link4'>Accessibility</Nav.Link>
                    </Nav>
                </Navbar.Collapse>  
            </Container>
        </Navbar>
        <Navbar className='bg-body-tertiary' data-bs-theme='dark'>
            <Container>
                <Navbar.Text>©2024 Bubblery Company. All rights reserved</Navbar.Text>
                <Navbar.Text>Created by: <a href='https://www.linkedin.com/in/jesus-aguayo/'>Jesus Aguayo</a></Navbar.Text>
            </Container>
        </Navbar>
    </section>
    );
}